module.exports = __webpack_public_path__ + "static/media/save.2c83b1ac.png";